import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { flatMap, map } from 'rxjs/operators';
import { FlightLogHttpClient } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.service';
import { UpdateFlightLogSummary } from 'src/store/flight-log-summary/flight-log-summary.actions';
import { FlightLogSummaryEntity } from 'src/store/flight-log-summary/flight-log-summary.model';
import {
  DeleteFlightLog,
  FlightLogActionTypes,
  FlightLogEdited,
  UpdateFlightLog,
  UpsertFlightLog,
} from 'src/store/flight-log/flight-log.actions';

@Injectable()
export class FlightLogEffects {
  constructor(private actions$: Actions, private _flightLogs: FlightLogHttpClient) {}

  @Effect({ dispatch: false })
  public onEditFetchLatest = this.actions$.pipe(
    ofType<FlightLogEdited | DeleteFlightLog>(
      FlightLogActionTypes.FlightLogEdited,
      FlightLogActionTypes.DeleteFlightLog,
    ),
    flatMap(async ({ payload: { id } }) => {
      // Fetch latest state for store
      await this._flightLogs.getById(id).toPromise();
    }),
  );

  @Effect()
  public updateSummary = this.actions$.pipe(
    ofType<UpsertFlightLog | UpdateFlightLog>(FlightLogActionTypes.UpsertFlightLog),
    map((action) => {
      const changes: Partial<FlightLogSummaryEntity> =
        action instanceof UpsertFlightLog
          ? action.payload.flightLog
          : action.payload.flightLog.changes;
      return new UpdateFlightLogSummary({
        flightLogSummary: {
          id: String(action.payload.flightLog.id),
          changes,
        },
      });
    }),
  );
}
